import { Truck, Store, Building2 } from "lucide-react";
import { pillOf, warnOf } from "@/lib/orders";
import { formatCZK } from "@/lib/format";

// Drobnosti sdílené seznamem, tabulí, kalendářem, detailem i Dodávkami na telefonu (311).
export function StatusPill({ o, className = "" }) {
  const p = pillOf(o);
  return (
    <span className={`inline-flex items-center gap-1.5 h-6 px-2.5 rounded-full text-[12px] font-semibold whitespace-nowrap ${p.pill} ${className}`}
      data-testid={`order-pill-${o.id}`}>
      <i className={`w-[7px] h-[7px] rounded-full ${p.dot}`} aria-hidden />{p.label}
    </span>
  );
}

export function SupplierMark({ name, size = 34 }) {
  const ini = (name || "?").replace(/[^\p{L}\p{N}]/gu, "").slice(0, 2).toUpperCase() || "?";
  return (
    <span style={{ width: size, height: size }} aria-hidden
      className="rounded-[10px] bg-secondary text-foreground grid place-items-center text-[12px] font-extrabold shrink-0">{ini}</span>
  );
}

export function ModeIcon({ o, size = 15, className = "" }) {
  const Icon = o.delivery?.mode === "pickup" ? Store : o.delivery?.mode === "office" ? Building2 : Truck;
  return <Icon size={size} className={`shrink-0 ${className}`} aria-hidden />;
}

export function Warn({ o, today, className = "" }) {
  const w = warnOf(o, today);
  if (!w) return null;
  return <span className={`text-[12px] font-semibold ${w.tone === "red" ? "text-destructive" : "text-amber-700 dark:text-amber-400"} ${className}`}>{w.text}</span>;
}

// Částka podle Zobrazení › Částky (391): bez DPH / s DPH / obojí (bez DPH a pod tím s DPH); obě v title.
// Výchozí s DPH — kolik se platí (Dodávky na telefonu, osobní odběr). Bez práv k penězům nic.
export const orderAmount = (o, am) => (am === "gross" ? o.amount_gross : o.amount_net ?? o.amount_gross);
export function Amount({ o, className = "", am = "gross" }) {
  if (o.amount_gross == null) return <span className={`text-muted-foreground ${className}`}>—</span>;
  return (
    <span className={`tabular-nums whitespace-nowrap ${className}`} title={`${formatCZK(o.amount_gross)} s DPH · ${formatCZK(o.amount_net)} bez DPH`}>
      {formatCZK(orderAmount(o, am))}
      {am === "both" && <span className="block text-[12px] font-medium text-muted-foreground">s DPH {formatCZK(o.amount_gross)}</span>}
    </span>
  );
}

export const hasMoney = (o) => "amount_gross" in o;
